import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { flatMap, map, catchError } from 'rxjs/operators';
import { Epic, ofType } from 'redux-observable';
import { fetchExpenseEventsSuccess, fetchExpenseEventsError, FETCH_EXPENSE_EVENTS } from './actions';

export const fetchExpenseEventsEpic: Epic = action$ =>
  action$.pipe(
    ofType(FETCH_EXPENSE_EVENTS),
    flatMap(() =>
      ajax
        .getJSON('/content/workplace/en/participant/ri/content-pages/expense-events.model.json')
        .pipe(map((res: any) => fetchExpenseEventsSuccess(res[`:items`].root[`:items`].contentfragmentlist.items)))
        .pipe(catchError(ex => of(fetchExpenseEventsError(ex)))),
    ),
  );
